/**
 * The four categories every income type belongs to.
 *
 * Mirrors mos-mvp `src/types/incomeCategory.ts` -- the API validates the code
 * against the same list, so the two must agree. Stored as the CODE; the label
 * is display only, so the wording can change without touching stored data.
 *
 * Which category a type starts in is seed data (mos-mvp's income type
 * manifest), not a rule this file encodes: a tenant can change it per type on
 * the income type screen.
 */
export const INCOME_CATEGORIES = [
  { code: 'employment', label: 'Employment' },
  { code: 'selfEmployed', label: 'Self-Employed' },
  { code: 'realEstate', label: 'Real Estate' },
  { code: 'otherIncome', label: 'Other Income' },
] as const;

export type IncomeCategory = (typeof INCOME_CATEGORIES)[number]['code'];

/** The label to show, or null when the type has no category set. A type an
 *  admin created before choosing one is the ordinary way that happens. */
export const incomeCategoryLabel = (
  code: string | null | undefined,
): string | null =>
  INCOME_CATEGORIES.find((category) => category.code === code)?.label ??
  code ??
  null;
